import { useT } from '@/i18n';
import { labelChipStyle } from '../utils/label-color';
import type { ChipLabel } from './LabelChips';

interface LabelChipRowProps {
  labels: readonly ChipLabel[];
  max?: number;
}

export default function LabelChipRow({ labels, max = 3 }: LabelChipRowProps) {
  const t = useT();
  if (labels.length === 0) return null;

  return (
    <div
      style={{
        marginTop: 4,
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        flexWrap: 'nowrap',
        overflow: 'hidden',
      }}
    >
      {labels.slice(0, max).map((label) => (
        <span
          key={label.id}
          style={{
            ...labelChipStyle(label.color, true),
            flex: '0 0 auto',
            maxWidth: 110,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            borderRadius: 999,
            padding: '1px 8px',
            fontSize: 10,
            fontWeight: 600,
            lineHeight: 1.5,
          }}
        >
          {label.name}
        </span>
      ))}
      {labels.length > max && (
        <span style={{ fontSize: 10, color: '#8e8e93', flex: '0 0 auto' }}>
          {t.labels.more(labels.length - max)}
        </span>
      )}
    </div>
  );
}
